import styled from 'styled-components';

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColumnSpinner = styled.div`
  min-height: 300px;
  width: 345px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MasterRowContainer = styled.div`
  height: 64px;
  display: flex;
  background-color: ${({ theme }) => theme.black.a0};
  font-weight: 600;
  padding: 5px 0;
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;

export const BackLink = styled.div`
  padding-left: 25px;
  width: 345px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  > span {
    margin-left: 10px;
  }
  > div {
    transform: rotate(180deg);
  }
`;
